<ngx-hm-carousel
    #carousel
    class="carousel c-accent"
    [(ngModel)]="bannerIndex"
    [autoplay-direction]="'right'"
    [breakpoint]="breakPoint"
    show-num="auto"
    [autoplay]="autoplay"
    [between-delay]="2000"
    [data]="images"
    [infinite]="infiniteScroll"
    [aniTime]="300">
    <section ngx-hm-carousel-container [class.firstElement]="bannerIndex === 0" class="content">
        @for (avatar of images; track avatar; let i = $index) {
            <article
                class="item cursor-pointer"
                ngx-hm-carousel-item
                (click)="openActionLink(avatar, i + 1)"
                [attr.aria-label]="'Banner'">
                <img
                    class="img"
                    appDeferImageLoad
                    [imageSrc]="avatar?.image"
                    alt="banner"
                    [ngClass]="{ 'show-cursor': !!avatar.action_url }" />
            </article>
        }
        <ng-template #infiniteContainer></ng-template>
    </section>

    <ng-template #carouselContent let-avatar let-i="index">
        <div class="container-padding">
            <article class="item item-infinte cursor-pointer" [ngClass]="{ visible: bannerIndex === i }">
                <img
                    class="img img-infinite"
                    appDeferImageLoad
                    [imageSrc]="avatar?.image"
                    role="button"
                    tabindex="0"
                    alt="banner"
                    (click)="openActionLink(avatar, i + 1)"
                    [attr.aria-label]="'Banner'" />
            </article>
        </div>
    </ng-template>

    @if (images?.length > 1) {
        <ng-template #carouselPrev>
            <div class="click-area">
                <i class="material-icons">keyboard_arrow_left</i>
            </div>
        </ng-template>
        <ng-template #carouselNext>
            <div class="click-area">
                <i class="material-icons">keyboard_arrow_right</i>
            </div>
        </ng-template>
        <ng-template #carouselDot let-model>
            <div class="ball bg-accent" [class.visible]="model.index === model.currentIndex"></div>
        </ng-template>
    }
</ngx-hm-carousel>
